import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// import './registerServiceWorker';
// import Vue2TouchEvents from 'vue2-touch-events';
// import {MediaQueries} from 'vue-media-queries';
import priceFilter from "./filters/price";
import shortDateFilter from "./filters/shortDate";
// import Buefy from 'buefy';
import VueMq from 'vue-mq';

import 'vue-svgicon/dist/polyfill' // to make icons work in IE
import VueSVGIcon from 'vue-svgicon'
// import imageService from './services/imageService.vue';
// import basketService from './services/basketService.vue';
// import shopsService from './services/shopsService.vue';
// import 'buefy/dist/buefy.css'

// import BootstrapVue from 'bootstrap-vue'
// Vue.use(BootstrapVue);
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload);

import { LayoutPlugin, 
    ButtonPlugin, 
    CarouselPlugin, 
    ModalPlugin, 
    FormPlugin, 
    FormInputPlugin, 
    InputGroupPlugin, 
    BreadcrumbPlugin, 
    FormSelectPlugin, 
    // FormSelectOptionPlugin,
    FormRadioPlugin, 
    FormTextareaPlugin, 
    FormGroupPlugin, 
    AlertPlugin, 
    LinkPlugin, 
    FormCheckboxPlugin 
} from 'bootstrap-vue'
Vue.use(LayoutPlugin);
Vue.use(ButtonPlugin);
Vue.use(CarouselPlugin);
Vue.use(ModalPlugin);
Vue.use(FormPlugin);
Vue.use(FormInputPlugin);
Vue.use(InputGroupPlugin);
Vue.use(BreadcrumbPlugin);
Vue.use(FormSelectPlugin);
// Vue.use(FormSelectOptionPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(FormGroupPlugin);
Vue.use(AlertPlugin);
Vue.use(LinkPlugin);
Vue.use(FormCheckboxPlugin);

const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)

import lineClamp from 'vue-line-clamp';
Vue.use(lineClamp, {
    // importCss : true
})

// const mediaQueries = new MediaQueries();

// Vue.use(mediaQueries);
// Vue.use(Vue2TouchEvents);
Vue.use(VueSVGIcon);
// Vue.use(Buefy);
Vue.use(VueMq, {
    breakpoints: { // default breakpoints - customize this
        xs: 576,
        sm: 768,
        md: 993,
        lg: 1200,
        //xl: Infinity
    }
})

Vue.filter("price", priceFilter);
Vue.filter("shortDate", shortDateFilter);

Vue.config.productionTip = false;

window["app"] = new Vue({
  router,
  store,
//   mediaQueries: mediaQueries,
  render: (h) => h(App),
}).$mount('#app');
